module.exports = __webpack_public_path__ + "static/media/heatbliss-2.68527f1d.jpg";